import React from 'react'

class Documentation extends React.PureComponent {
  render() {
    return (
      <div>
        hello world (documentation page)
      </div>
    )
  }
}

export default Documentation


// WEBPACK FOOTER //
// ./src/Application/scenes/Site/Body/scenes/Documentation/index.jsx